import { IPhoneNumberForEdit } from '@nkr/models/phone-number';
import { Button } from 'react-bootstrap';

interface IProps {
    data: IPhoneNumberForEdit,
    showMobileProvider: boolean,
    viewOnly: boolean,
    onEdit: (id: number) => void,
    onDelete: (id: number) => void,
    onUndelete: (id: number) => void
}

const PhoneNumberListRow = (props: IProps) => {
    return (
        <tr>
            <td>{props.data.phoneTypeName}</td>
            <td>{props.data.number}</td>

            {props.showMobileProvider && (
                <td>{props.data.mobileProviderName ? props.data.mobileProviderName : 'N/A'}</td>
            )}

            {props.viewOnly == false && (
                <td style={{ textAlign: 'center' }}>
                    {!props.data.isDeleted ?
                        <>
                            <Button bsStyle='primary' bsSize='xs' style={{ marginRight: 5 }} onClick={() => props.onEdit(props.data.id)}>Edit</Button>
                            <Button bsStyle='danger' bsSize='xs' onClick={() => props.onDelete(props.data.id)}>Delete</Button>
                        </>
                        :
                        <Button bsStyle='danger' bsSize='xs' onClick={() => props.onUndelete(props.data.id)}>Undelete</Button>
                    }
                </td>
            )}
        </tr>
    )
}

export default PhoneNumberListRow;